import { Tag as AntdTag, TagProps as AntdTagProps } from "antd";
import { CMP_PREFIX } from "@/base/constant";
import { cx } from "antd-style";

export interface TagProps extends AntdTagProps {
  variant?: "solid" | "soft";
}

export const tagPrefixCls = `${CMP_PREFIX}-tag`;

export const Tag = ({ variant = "solid", className, ...props }: TagProps) => {
  return (
    <AntdTag
      {...props}
      className={cx(className, variant === "soft" && `${tagPrefixCls}-soft`)}
    />
  );
};
